import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path } from "react-native-svg";

import AppTheme from "../../../AppTheme";

export default function UndoIcon(props) {
  return (
    <Svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7138 10.495C15.2436 6.99683 13.1251 4.50213 10.1277 4.2149C7.66627 3.97903 5.02813 5.28179 2.74516 8.03318C2.74558 7.74553 2.74756 7.46179 2.75041 7.19402C2.75522 6.74164 2.76245 6.34103 2.76847 6.05361C2.77148 5.90997 2.77419 5.79477 2.77613 5.71572L2.77842 5.62525L2.77904 5.60218L2.77919 5.5965L2.77923 5.59517L2.77923 5.59488L2.77924 5.59485L2.77924 5.59483C2.7967 4.96265 2.29838 4.43601 1.6662 4.41853C1.03401 4.40106 0.507359 4.89938 0.489884 5.53157L1.63456 5.56321L0.489882 5.53165L0.489878 5.5318L0.489864 5.53228L0.489817 5.53401L0.489641 5.54051L0.488984 5.56526L0.4866 5.65935C0.484592 5.74092 0.481822 5.85893 0.478748 6.00564C0.472603 6.29894 0.465229 6.70764 0.460311 7.16964C0.450549 8.08669 0.450127 9.23888 0.490673 10.1142L0.490593 10.1142L0.491381 10.1277C0.507142 10.3986 0.576219 10.6637 0.69465 10.9077C0.81308 11.1518 0.978533 11.3702 1.18152 11.5502C1.38451 11.7302 1.62104 11.8683 1.87754 11.9567C2.12741 12.0428 2.39144 12.0801 2.65525 12.0665L7.05679 11.9295C7.68891 11.9098 8.1854 11.3814 8.16573 10.7493C8.14606 10.1172 7.61767 9.62069 6.98555 9.64036L4.32087 9.72329C6.34623 7.16744 8.41157 6.35117 9.90923 6.49469C11.5484 6.65176 13.0713 8.02754 13.444 10.8C13.5282 11.4268 14.1046 11.8667 14.7314 11.7824C15.3582 11.6982 15.798 11.1218 15.7138 10.495Z"
        fill={AppTheme.DEFAULT_COLOR}
      />
    </Svg>
  );
}
